import React from 'react';
export function ProblemSection() {
  return <section className="bg-ev-paper px-4 py-4" data-id="element-139" data-mp="14h50941kq3yf">
      <div className="mx-auto max-w-3xl text-center" data-id="element-140" data-mp="2lstj7fjy28ej">
        <h2 className="mb-2 font-display text-[21px] leading-tight text-ev-black sm:text-3xl" data-id="element-141" data-mp="2lq8gypfqhqg9">
          Stop Guessing Where the EV or Hybrid Fault Starts
        </h2>
        <p className="text-[13px] font-medium leading-snug text-ev-black/80 sm:text-[15px]" data-id="element-142" data-mp="2vppkp1bfdu9l">
          Vehicle won&apos;t enter READY mode? Charging, battery or propulsion warnings appearing?
          BMS, inverter, motor, sensors, thermal systems... where does the fault actually start?{' '}
          <span className="font-extrabold text-ev-black" data-id="element-143" data-mp="3jf0lujwotqo9">EV &amp; HYBRID DIAGNOSTIC PRO™</span>{' '}
          gives you an organized visual troubleshooting system to help you understand modern EV and
          hybrid systems and follow a clearer diagnostic path.{' '}
          <span className="font-extrabold text-ev-black" data-id="element-144" data-mp="1k37ogm5zmjb0">Identify. Test. Diagnose.</span>
        </p>
      </div>
    </section>;
}